import { RedirectException } from 'found';
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

// path is complete if it follows the structure /:lang/crawler/:url/:category/:section
// NOT complete: "/en/crawler/cnn.com/"
// NOT complete: "/en/crawler/cnn.com/on-page"
// YES complete: "/en/crawler/cnn.com/on-page/title-issues"
export const isCompletePath = pathname => !!(
  (typeof pathname === 'string') &&
  (pathname.match(/^\/(en|fr|de|pt|es|nl)\/crawler\/[^/]+\/[^/]+\/[^/]+\/?$/))
);

export const stripTailSlash = path => (path || '').replace(/\/+$/, '');

export const crawlerServerRedirects = (req, res, next) => {
  const path = req.originalUrl || '';
  if (isCompletePath(path)) {
    return next();
  }

  const redirects = [
    { from: /\/on-page\//, to: 'on-page/title-issues' },
    { from: /\/http-status\//, to: 'http-status/5xx-errors' },
    { from: /\/indexing\//, to: 'indexing/non-indexable-pages' },
    { from: /\/canonical\//, to: 'canonical/canonical-issues' }
  ];

  const redirectPath = (redirects.find(rd => path.match(rd.from)) || redirects[0]).to;
  return res.redirect(301, `${req.baseUrl}/${redirectPath}`);
};

export const renderFunction = ({ Component, props, match }, options = {}) => {
  const pathname = get(match, 'location.pathname', null);
  if (!Component || !pathname) {
    return null;
  }

  if (options.redirectTo && !isCompletePath(pathname)) {
    const newAddress = `${stripTailSlash(pathname)}${options.redirectTo}`;
    throw new RedirectException({
      pathname: newAddress,
      state: { hasRedirect: { from: pathname, to: newAddress } }
    });
  }

  return <Component {...props} />;
};

renderFunction.propTypes = {
  Component: PropTypes.node,
  props: PropTypes.object,
  match: PropTypes.object
};

export const createRenderFunction = options => data => renderFunction(data, options);
